import React from 'react';
import Temporary from 'components/error/temporary';

const TemporaryPage = () => {
  return <Temporary></Temporary>;
};

export default TemporaryPage;
